// extracted by mini-css-extract-plugin
module.exports = {"modal":"CorrectElevation--modal--2mdah"};